export interface B2BLanguageSwitchConfig {
  currentLanguage: string;
  options: B2BLanguageSwitchOption[];
}

export interface B2BLanguageSwitchOption {
  href: string;
  label: string;
  value: string;
}

const B2B_LANGUAGE_EXCLUDED_PATHS = new Set(["/"]);

export const B2B_LANGUAGES: B2BLanguageSwitchOption[] = [
  {
    href: "",
    label: "English",
    value: "en",
  },
  {
    href: "",
    label: "हिंदी",
    value: "hindi",
  },
];

const LANGUAGE_PREFIXES = new Set(B2B_LANGUAGES.map(({ value }) => value).filter(Boolean));

function normalizePath(pathname: string): string {
  if (!pathname) return "/";
  if (pathname.length > 1 && pathname.endsWith("/")) {
    return pathname.slice(0, -1);
  }
  return pathname;
}

function resolveCurrentPath(pathname: string) {
  const normalizedPath = normalizePath(pathname);
  const [, firstSegment = "", ...remainingSegments] = normalizedPath.split("/");
  const hasLanguagePrefix = LANGUAGE_PREFIXES.has(firstSegment) && firstSegment !== "en";
  const englishPath = hasLanguagePrefix
    ? normalizePath(`/${remainingSegments.join("/")}`)
    : normalizedPath;

  return {
    currentLanguage: hasLanguagePrefix ? firstSegment : "en",
    englishPath,
  };
}

export function getB2BLanguageSwitchConfig(
  pathname: string,
  search = ""
): B2BLanguageSwitchConfig | null {
  const { currentLanguage, englishPath } = resolveCurrentPath(pathname);

  // Enable language switch by default for all content pages.
  // Only explicitly excluded paths are hidden.
  if (B2B_LANGUAGE_EXCLUDED_PATHS.has(englishPath)) {
    return null;
  }

  return {
    currentLanguage,
    options: B2B_LANGUAGES.map(({ label, value }) => ({
      label,
      value,
      href: value === "en" ? `${englishPath}${search}` : `/${value}${englishPath}${search}`,
    })),
  };
}
